// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal[data-v-f7aca0d6] .v--modal-box.v--modal {
  /*.conf-item {
                height: 70px;
            }*/
}
.custom-modal[data-v-f7aca0d6] .v--modal-box.v--modal .header {
  padding: 15px 20px 4px 15px;
}
.custom-modal[data-v-f7aca0d6] .v--modal-box.v--modal .body {
  overflow-y: hidden;
  width: 100%;
}
.custom-modal[data-v-f7aca0d6] .v--modal-box.v--modal label.custom-checkbox {
  padding-left: 26px;
}
.custom-modal[data-v-f7aca0d6] .v--modal-box.v--modal .custom-input-text-placeholder.up {
  font-size: 0.8em;
}
.conference-info[data-v-f7aca0d6] {
  position: relative;
  color: var(--toolbtn-color);
  font-size: 16px;
  height: 240px;
  margin: 0 auto;
}
.conference-info[data-v-f7aca0d6] .non-border-input {
  width: 100%;
}
.conference-info[data-v-f7aca0d6] .date-picker-input-from,
.conference-info[data-v-f7aca0d6] .date-picker-input-to {
  background-color: inherit;
}
.conference-info .conf-modes[data-v-f7aca0d6] {
  flex-direction: row;
  justify-content: space-between;
}
.conference-info .subject .custom-input-text[data-v-f7aca0d6] {
  width: 100%;
}
.conference-info .custom-input-text-placeholder[data-v-f7aca0d6] {
  color: var(--modal-text-color) !important;
}
.conference-info .conf-auth[data-v-f7aca0d6] {
  flex-direction: row;
}
.conference-info .conf-settings a[data-v-f7aca0d6] {
  color: var(--modal-elem-color);
  cursor: pointer;
}
.conference-info .conf-settings a[data-v-f7aca0d6]:hover {
  color: var(--modal-elem-color);
  text-decoration: none;
}
.footer .edit[data-v-f7aca0d6] {
  display: inline-flex;
}
.footer .edit i[data-v-f7aca0d6] {
  font-size: 22px;
  font-weight: 300;
  color: var(--toolbtn-color);
}
.footer .edit i[data-v-f7aca0d6]:hover {
  color: var(--toolbtn-color-hover);
}
.footer .edit div[data-v-f7aca0d6] {
  margin-right: 24px;
}
.footer .buttons[data-v-f7aca0d6] {
  display: contents;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNewManagment/conferenceInfo.vue"],"names":[],"mappings":"AAAA;EACE;;cAEY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".custom-modal[data-v-f7aca0d6] .v--modal-box.v--modal {\n  /*.conf-item {\n                height: 70px;\n            }*/\n}\n.custom-modal[data-v-f7aca0d6] .v--modal-box.v--modal .header {\n  padding: 15px 20px 4px 15px;\n}\n.custom-modal[data-v-f7aca0d6] .v--modal-box.v--modal .body {\n  overflow-y: hidden;\n  width: 100%;\n}\n.custom-modal[data-v-f7aca0d6] .v--modal-box.v--modal label.custom-checkbox {\n  padding-left: 26px;\n}\n.custom-modal[data-v-f7aca0d6] .v--modal-box.v--modal .custom-input-text-placeholder.up {\n  font-size: 0.8em;\n}\n.conference-info[data-v-f7aca0d6] {\n  position: relative;\n  color: var(--toolbtn-color);\n  font-size: 16px;\n  height: 240px;\n  margin: 0 auto;\n}\n.conference-info[data-v-f7aca0d6] .non-border-input {\n  width: 100%;\n}\n.conference-info[data-v-f7aca0d6] .date-picker-input-from,\n.conference-info[data-v-f7aca0d6] .date-picker-input-to {\n  background-color: inherit;\n}\n.conference-info .conf-modes[data-v-f7aca0d6] {\n  flex-direction: row;\n  justify-content: space-between;\n}\n.conference-info .subject .custom-input-text[data-v-f7aca0d6] {\n  width: 100%;\n}\n.conference-info .custom-input-text-placeholder[data-v-f7aca0d6] {\n  color: var(--modal-text-color) !important;\n}\n.conference-info .conf-auth[data-v-f7aca0d6] {\n  flex-direction: row;\n}\n.conference-info .conf-settings a[data-v-f7aca0d6] {\n  color: var(--modal-elem-color);\n  cursor: pointer;\n}\n.conference-info .conf-settings a[data-v-f7aca0d6]:hover {\n  color: var(--modal-elem-color);\n  text-decoration: none;\n}\n.footer .edit[data-v-f7aca0d6] {\n  display: inline-flex;\n}\n.footer .edit i[data-v-f7aca0d6] {\n  font-size: 22px;\n  font-weight: 300;\n  color: var(--toolbtn-color);\n}\n.footer .edit i[data-v-f7aca0d6]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.footer .edit div[data-v-f7aca0d6] {\n  margin-right: 24px;\n}\n.footer .buttons[data-v-f7aca0d6] {\n  display: contents;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
